import AbsModule from '../common/AbsModule';
import { lnbMarkup } from '../common/LnbCommon';
import { PURPLE_DEVICE } from '../common/const';

class Lnb extends AbsModule {
    startSetting() {
        const { lnbCallbackMap } = this.moduleData || {};

        // onClick 콜백 실행
        $('#nc-cnb .ncc-lnb-m [data-callback]').on('click', e => {
            e.preventDefault();

            const target = e.currentTarget;
            const callbackKey = target?.dataset?.callback;
            const callback = lnbCallbackMap.get(callbackKey);
            
            // callback 실행
            if(typeof callback === 'function') {
                callback(e);
            }

            return false;
        });
    }

    makeMarkup() {
        const { isPurple, purpleDevice } = this.com || {};
        const { lnbData, active } = this.moduleData || {};

        return `<nav class="ncc-lnb-m">
            ${lnbMarkup({
                lnbData, 
                isSub: false, 
                active,
                isPurple,
                isPurpleMobile: isPurple && purpleDevice === PURPLE_DEVICE.mobile
            })}
        </nav>`;
    }
}

export default Lnb;